import React,{Component} from 'react'

import '../../css/common/IconFontBox.css'

class IconFontBox extends Component {
    constructor() {
        super();
    }
    render() {
        return(
            <div className="icon-box lecture-bottom_btn weui-flex__item flex_1 weui-flex" onClick={this.props.onClickHandle}>
                <div className="icon-box-img">
                    {this.props.icon}
                </div>
                <div className="icon-box-title">{this.props.title}</div>
            </div>
        )
    }
}

export default IconFontBox;


// WEBPACK FOOTER //
// ./src/components/details/IconFontBox.js